import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { ArrowLeft, Search } from 'lucide-react';

const NotFoundPage = () => (
  <div className="min-h-screen bg-gray-50">
    <Helmet>
      <title>{'Page Not Found | PeptideSciences.ai'}</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <Navigation />
    <div className="max-w-2xl mx-auto px-4 py-24 text-center">
      <div className="text-8xl font-bold text-gray-200 mb-4">404</div>
      <h1 className="text-3xl font-bold text-gray-900 mb-4" data-testid="not-found-title">Page Not Found</h1>
      <p className="text-lg text-gray-600 mb-8">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/" className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all" data-testid="go-home-btn">
          <ArrowLeft className="mr-2" size={18} /> Go to Homepage
        </Link>
        <Link to="/research" className="inline-flex items-center justify-center px-6 py-3 bg-white text-gray-700 rounded-lg font-semibold hover:bg-gray-100 transition-all border border-gray-300" data-testid="browse-research-btn">
          <Search className="mr-2" size={18} /> Browse Research
        </Link>
      </div>
    </div>
    <Footer />
  </div>
);

export default NotFoundPage;
